(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-faq';

  function initSection(section) {
    var items = section.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        if (isExpanded) return;
        items.forEach(function (other) {
          if (other === item) return;
          var otherTrigger = other.querySelector('[data-faq-trigger]');
          var otherAnswer = other.querySelector('[data-faq-answer]');
          if (otherTrigger && otherAnswer && otherTrigger.getAttribute('aria-expanded') === 'true') {
            collapse(otherTrigger, otherAnswer);
          }
        });
        expand(trigger, answer);
      });
    });
  }

  function expand(trigger, answer) {
    trigger.setAttribute('aria-expanded', 'true');
    answer.removeAttribute('hidden');
    answer.setAttribute('aria-hidden', 'false');
  }

  function collapse(trigger, answer) {
    trigger.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.setAttribute('hidden', '');
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();